import MultiplierSettingsPage from "@/pages/settings/multiplier/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/settings/multiplier")({
    component: MultiplierSettingsPage,
});
